import { render, staticRenderFns } from "./GetInvoiceInformationForReminderListForm.vue?vue&type=template&id=c2812140&scoped=true&"
import script from "./GetInvoiceInformationForReminderListForm.vue?vue&type=script&lang=js&"
export * from "./GetInvoiceInformationForReminderListForm.vue?vue&type=script&lang=js&"
import style0 from "./GetInvoiceInformationForReminderListForm.vue?vue&type=style&index=0&id=c2812140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2812140",
  null
  
)

export default component.exports